<template>
  <p
    v-if="element.settings.description"
    v-html="element.settings.description"
    :id="`description-${element.id}`"
    :style="labelStyle"
    class="form-description fw-normal text-break p-0 m-0"
  ></p>
</template>

<script>
export default {
  name: 'FormDescription',
  props: {
    element: {
      type: Object,
      required: true,
    },
    labelStyle: { type: Object, default: () => {} },
  },
};
</script>

<style scoped>
.form-description {
  padding-bottom: 25px !important;
  font-size: 14px;
  font-family: 'OpenSans-Regular';
  line-height: 20px;
  letter-spacing: -0.02em;
  white-space: pre-line;
  color: #919191;
}
</style>
